import { makeStyles, createStyles } from '@material-ui/core';

// スタイリング
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
    },
    load: {
      height: '100%',
    },
    // データ表示のテーブルで使うスタイル
    descriptionItem: {
      display: 'flex',
    },
    description: {
      flex: '1 !important',
      padding: '4px 8px',
    },
    description7: {
      flex: '0 0 70%',
      borderRight: '2px solid #e8e8e8',
      paddingRight: '8px',
      justifyItems: 'center',
    },
    description3: {
      flex: '0 0 30%',
      paddingLeft: '8px',
      justifyItems: 'center',
    },
    descriptionTitle: {
      marginBottom: '0',
    },
    // 一覧テーブルで使うスタイル＾
    container: {
      margin: '5px',
      wordBreak: 'break-all', // 文字が折り返す
      whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
    },
    oddRow: {
      backgroundColor: '#e0e0e0',
    },
    evenRow: {
      backgroundColor: '#f4f4f4',
    },
    // 文字は左寄せ
    stringRow: {
      textAlign: 'left',
    },
    // 数値は右寄せ
    numRow: {
      textAlign: 'right',
    },
    // ボタンは中央寄せ
    buttonRow: {
      textAlign: 'center',
    },
    header: {
      // 一覧のヘッダ
      fontSize: '16px',
      textAlign: 'center',
      padding: '5px',
      // color: '#0062cc',
      backgroundColor: '#fafafa',
      '&::after': {
        content: '""',
        position: 'absolute',
        right: '0',
        top: '10%', // 上側の隙間のサイズを調整
        bottom: '10%', // 下側の隙間のサイズを調整
        width: '1px',
        backgroundColor: '#e0e0e0', // 縦線の色
      },
    },
    linkButton: {
      // ソートボタンをした後に出る影を無効化
      '&:focus': {
        boxShadow: 'none',
      },
    },
    cell: {
      fontSize: '16px',
      position: 'relative',
      padding: '5px',
      '&::after': {
        content: '""',
        position: 'absolute',
        right: '0',
        top: '10%', // 上側の隙間のサイズを調整
        bottom: '10%', // 下側の隙間のサイズを調整
        width: '1px',
        backgroundColor: '#ffffff', // 縦線の色
      },
    },
    // 各一覧テーブルの幅
    eqListWidth: {
      width: 1600,
    },
    deviceListWidth: {
      width: 1600,
    },
    partsListWidth: {
      width: 1600,
    },
    deviceItemListWidth: {
      width: 1600,
    },
    deviceMaintListWidth: {
      width: 860,
    },
    deviceTroubleListWidth: {
      width: 1310,
    },
    eqMaintListWidth: {
      width: 1150,
    },
    eqAchieveListWidth: {
      width: 1670,
    },
    eqTroubleListWidth: {
      width: 1400,
    },
    eqCsetListWidth: {
      width: 960,
    },
    // 各一覧テーブルの高さ
    eqListHeight: {
      height: 600,
    },
    deviceListHeight: {
      height: 550,
    },
    partsListHeight: {
      height: 600,
    },
    deviceItemListHeight: {
      height: 600,
    },
    deviceMaintListHeight: {
      height: 600,
    },
    deviceTroubleListHeight: {
      height: 600,
    },
    eqMaintListHeight: {
      height: 550,
    },
    eqAchieveListHeight: {
      height: 500,
    },
    eqTroubleListHeight: {
      height: 540,
    },
    eqCsetListHeight: {
      height: 550,
    },
    // テーブルのは左列固定で使う
    stickyHeaderFirst: {
      zIndex: 13,
      left: 0,
      position: 'sticky',
      background: '#fafafa',
    },
    stickyHeaderSecond: {
      zIndex: 12,
      left: '100px', // 第1列の幅に応じて調整。ここではheaderWidth.equipmentIdの値を基にしています。
      position: 'sticky',
      background: '#fafafa',
    },
    stickyHeaderOther: {
      zIndex: 11,
    },
    stickyColumnFirst: {
      zIndex: 3,
      left: 0,
      position: 'sticky',
      background: '#fafafa',
    },
    stickyColumnSecond: {
      zIndex: 2,
      left: '100px', // 第1列の幅に応じて調整。ここではheaderWidth.equipmentIdの値を基にしています。
      position: 'sticky',
      background: '#fafafa',
    },
    stickyColumnOther: {
      zIndex: 1,
    },
    // `Table`の親要素（`TableContainer`またはその他のDIV）に適用するスタイル
    tableContainer: {
      overflowX: 'auto',
      wordBreak: 'break-all', // 文字が折り返す
      whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
    },
    tableParts: {
      width: '2800px', // 全列の幅の合計に応じて調整
    },
    tableDeviceItem: {
      width: '2030px', // 全列の幅の合計に応じて調整
    },
    cellFix: {
      // 固定列のセルのスタイル cellとは区切りの縦線の色が違う
      fontSize: '16px',
      padding: '5px',
      '&::after': {
        content: '""',
        position: 'absolute',
        right: '0',
        top: '10%', // 上側の隙間のサイズを調整
        bottom: '10%', // 下側の隙間のサイズを調整
        width: '1px',
        backgroundColor: '#e0e0e0', // 縦線の色
      },
    },
    // ページングで使うスタイル
    paging: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '5px',
    },
    pagingText: {
      minWidth: '200px',
      textAlign: 'center',
    },
    // メニュー画面で使う
    gridWidth2: {
      // 要素が二つ
      width: '400px',
    },
    gridWidth3: {
      // 要素が三つ
      width: '600px',
    },
    buttonCard: {
      width: '100%',
    },
    cardBody: {
      padding: '10px',
      textAlign: 'center',
    },
    menuButton: {
      width: '150px',
      height: '70px',
    },
  }),
);

// 一覧テーブルの幅
export const headerWidth = {
  // 設備一覧画面
  equipmentId: 110,
  eqButton: 110,
  officeName: 300,
  institution: 200,
  eqLocation: 200,
  equipmentName: 230,
  eqNo: 150,
  eq1Name: 150,
  secName: 150,

  // 設備機器一覧画面
  mstId: 110,
  dvButton1: 110,
  dvButton2: 120,
  roomName: 300,
  deviceName: 300,
  tagNo: 160,
  eqType: 160,
  seizoNo: 160,
  makerName: 180,

  // 機器部品一覧画面
  partsId: 100,
  partsName: 250,
  partsNo: 250,
  qty: 200,
  partsClass: 250,
  repYear: 150,
  type: 250,
  partsMakerName: 250,
  mainteType: 150,
  insItem: 200,
  partsUse: 250,
  biko: 300,
  changeDate: 200,

  // 機器点検項目一覧画面
  inspectItem: 350,
  inspectItemSub: 250,
  inspectDetails: 400,
  criterion: 250,
  inspectYear: 130,
  inspectWorkType: 150,
  s1: 100,
  s2: 100,
  s3: 100,
  s4: 100,
  s5: 100,

  // 機器点検履歴画面
  workHisId: 110,
  workSYmd: 250,
  workType: 150,
  jobNo: 150,
  deviceReportNo: 200,

  // 機器故障修理履歴
  troubleId: 110,
  trDate: 150,
  trJobNo: 150,
  coOther: 200,
  caOther: 200,
  diOther: 200,
  trSummary: 300,

  // 設備点検履歴
  eqWorkHisId: 150,
  eqWorkSYmd: 250,
  eqWorkName: 200,
  eqWorkType: 200,
  eqJobNo: 150,
  eqReportNo: 200,

  // 設備点検実績一覧
  achieveMstId: 110,
  achieveDeviceNameDsp: 150,
  achieveSeizoNo: 150,
  achieveNonyuYear: 120,
  achieveY14: 60,
  achieveY13: 60,
  achieveY12: 60,
  achieveY11: 60,
  achieveY10: 60,
  achieveY9: 60,
  achieveY8: 60,
  achieveY7: 60,
  achieveY6: 60,
  achieveY5: 60,
  achieveY4: 60,
  achieveY3: 60,
  achieveY2: 60,
  achieveY1: 60,
  achieveY0: 60,
  achieveFutuShuuki: 120,
  achieveEqReportNo: 120,

  // 設備故障修理履歴
  troubleEqId: 150,
  trEqTrName: 200,
  trEqSummary: 300,
  trEqName: 150,
  trEqStartDate: 250,
  trEqJobNo: 150,
  trEqReportNo: 200,

  // 設備改造移設撤去履歴
  cSetId: 110,
  cSetType: 200,
  cSetDate: 150,
  cSetName: 200,
  cSetSummary: 300,
};

// データ表示のテーブルの全幅
export const dataDispWidth = {
  userInfo: '450px',
  eqList: '450x',
  deviceList: '1350px',
  deviceDetail: '1350px',
  deviceDetail450: '450px',
  deviceDetail900: '900px',
  deviceDetail1350: '1350px',
  partsList: '900px',
  partsDetail: '900px',

  deviceMaintMenu: '900px',
  deviceMaintDetail: '900px',
  deviceTroubleDetail450: '450px',
  deviceTroubleDetail900: '900px',

  eqMaintBase: '900px',
  eqMaintDetail: '900px',
  eqTroubleDetail: '900px',
  eqCsetDetail: '450px',
};

// データ表示のテーブルのラベルとコンテンツのスタイル
export const userLabelStyle: React.CSSProperties = {
  padding: '4px 8px',
  backgroundColor: '#e0e0e0',
  width: '150px',
  fontSize: '16px',
  textAlign: 'right' as const,
  fontWeight: 'bold' as const,
};

export const userContentStyle: React.CSSProperties = {
  padding: '4px 8px',
  backgroundColor: '#fafafa',
  width: '300px',
  fontSize: '16px',
  whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
  wordBreak: 'break-all', // はみだし対策（未解決）
};

export const labelStyle: React.CSSProperties = {
  padding: '4px 8px',
  backgroundColor: '#e0e0e0',
  width: '150px',
  fontSize: '16px',
  textAlign: 'right' as const,
  fontWeight: 'bold' as const,
  whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
  wordBreak: 'break-all', // はみだし対策（未解決）
};

const baseContentStyle: React.CSSProperties = {
  padding: '4px 8px',
  width: '300px',
  fontSize: '16px',
  whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
  wordBreak: 'break-all', // はみだし対策（未解決）
};

export const contentStyle: React.CSSProperties = {
  ...baseContentStyle,
  backgroundColor: '#fafafa',
};

export const contentStyle150: React.CSSProperties = {
  ...baseContentStyle,
  width: '150px',
  backgroundColor: '#fafafa',
};

export const yellowContentStyle: React.CSSProperties = {
  ...baseContentStyle,
  backgroundColor: '#ffffbd',
};

export const redContentStyle: React.CSSProperties = {
  ...baseContentStyle,
  backgroundColor: '#ffc8e3',
};

export const greenContentStyle: React.CSSProperties = {
  ...baseContentStyle,
  backgroundColor: '#c6ffc6',
};

export const contentHeight100 = {
  height: '100px',
  verticalAlign: 'top',
};

// 内容が無い時に表示するノーブレークスペース（高さ維持用）
export const blank = '\u00A0';

export default useStyles;
